import axios from "axios";
import Swal from "sweetalert2";
import { baseUrl, defaultAddErrorMessage, errorTranslate } from "./util";

export const getProductList = ({
  setProducts = function () {
    return;
  },
  setShared = function () {
    return;
  },
  setWriteAccess = function () {
    return;
  },
  chosenYear,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    params: {
      year: year ? year : chosenYear,
    },
  };

  axios(config)
    .then(function (response) {
      setProducts(response.data.data.filter((prod) => prod.is_product));
      setShared(response.data.shared);
      setWriteAccess(response.data.read_or_write);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteProduct = ({ id, business }) => {
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/product/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business_id: business,
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const getProductDetail = ({
  id,
  business,
  setName = function () {
    return;
  },
  setCreatedAt = function () {
    return;
  },
  setSoldToCustomer = function () {
    return;
  },
  setProductNum = function () {
    return;
  },
  setLeasedToCustomer = function () {
    return;
  },
  setTakeBackCustomer = function () {
    return;
  },
  setTotalProductsSold = function () {
    return;
  },
  setSoldUnit = function () {
    return;
  },
  setTotalProductsLeased = function () {
    return;
  },
  setTotalProductsTakeback = function () {
    return;
  },
  setLeasedUnit = function () {
    return;
  },
  setSalesShare = function () {
    return;
  },
  setIndividualProduct = function () {
    return;
  },
  setIndividualProductPackaging = function () {
    return;
  },
  setFinalWeight = function () {
    return;
  },
  setVariationCategories = function () {
    return;
  },
  setCertificates = function () {
    return;
  },
  setCountryOrigin = function () {
    return;
  },
  setFunctionalUnit = function () {
    return;
  },
  setFunctionalUnitNum = function () {
    return;
  },
  setCountryCode = function () {
    return;
  },
  setLifetimeFunctional = function () {
    return;
  },
  setLifetimeFunctionalUnit = function () {
    return;
  },
  setFunctionalUnitDesc = function () {
    return;
  },
  setObjects = function () {
    return;
  },
  setWasteWeight = function () {
    return;
  },
  setTotalWeight = function () {
    return;
  },
  setWasteWeighIn = function () {
    return;
  },
  setTotalWeighIn = function () {
    return;
  },
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/product/" + id + "/detail",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business_id: business,
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(response.data.data.product);
      setName(response.data.data.product.name);
      setCreatedAt(response.data.data.product.created_at);
      setSoldToCustomer(response.data.data.product.sold_to_customer);
      setProductNum(response.data.data.product.product_num);
      setLeasedToCustomer(response.data.data.product.leased_to_customer);
      setTakeBackCustomer(response.data.data.product.take_back_customer);
      setTotalProductsSold(response.data.data.product.total_products_sold);
      setSoldUnit(response.data.data.product.sold_unit);
      setTotalProductsLeased(response.data.data.product.total_products_leased);
      setTotalProductsTakeback(
        response.data.data.product.total_products_takeback
      );
      setLeasedUnit(response.data.data.product.leased_unit);
      setSalesShare(response.data.data.product.sales_share);
      setIndividualProduct(response.data.data.product.individual_weight);
      setIndividualProductPackaging(
        response.data.data.product.individual_weight_packaging
      );
      setFinalWeight(response.data.data.product.your_weigh_in);
      setVariationCategories(response.data.data.product.variation_categories);
      setCertificates(response.data.data.product.certificates);
      setCountryOrigin(response.data.data.product.country_origin);
      setFunctionalUnit(response.data.data.product.functional_unit);
      setFunctionalUnitNum(response.data.data.product.functional_unit_num);
      setLifetimeFunctional(response.data.data.product.lifetime_functional);
      setLifetimeFunctionalUnit(
        response.data.data.product.lifetime_functional_unit
      );
      setFunctionalUnitDesc(response.data.data.product.functional_unit_desc);
      setWasteWeight(response.data.data.product.waste_weight);
      setTotalWeight(response.data.data.product.total_weight);
      setWasteWeighIn(response.data.data.product.waste_weigh_in);
      setTotalWeighIn(response.data.data.product.total_weigh_in);
    })

    .catch(function (error) {
      console.log(error);
    });
};

export const createProduct = ({
  name,
  year,
  subgroupId,
  business,
  variationCategories,
  productNum,
  setStatus = function () {
    return;
  },
  setErrorMessage = function () {
    return;
  },
  setIdBusiness = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    name: name,
    product_num: productNum,
    variation_categories: variationCategories,
    is_product: true,
    components: [],
    year: year,
    subgroup: subgroupId,
    business_id: business,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/product/add",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      // console.log(JSON.stringify(response.data));
      // setSaving(false)
      setStatus(true);
      setIdBusiness(response.data.data.productID);

      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      // Swal.fire(
      //   "Error!",
      //   error,
      //   "error"
      // );
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      // setSaving(false)
    });
};

export const updateProduct = ({
  id,
  name,
  business,
  soldToCustomer,
  productNum,
  unit,
  leasedToCustomer,
  takeBackCustomer,
  totalProductsSold,
  soldUnit,
  totalProductsLeased,
  leasedUnit,
  salesShare,
  salesQty,
  salesUnit,
  individualProduct,
  individualProductPackaging,
  finalWeight,
  variationCategories,
  certificates,
  countryOrigin,
  functionalUnitNum,
  functionalUnit,
  countryCode,
  totalProductsTakeback,
  lifetimeFunctional,
  lifetimeFunctionalUnit,
  functionalUnitDesc,
  wasteWeight,
  totalWeight,
  wasteWeighIn,
  totalWeighIn,
  setErrorMessage = function () {
    return;
  },
  callback,
}) => {
  var data = JSON.stringify({
    name: name || null,
    components: [],
    product_num: productNum || null,
    sold_to_customer: soldToCustomer || null,
    leased_to_customer: leasedToCustomer || null,
    take_back_customer: takeBackCustomer || null,
    total_products_sold: totalProductsSold || null,
    sold_unit: soldUnit || null,
    total_products_leased: totalProductsLeased || null,
    total_products_takeback: totalProductsTakeback || null,
    leased_unit: leasedUnit || null,
    sales_share: salesShare || null,
    sales_qty: salesQty || null,
    sales_unit: salesUnit || null,
    individual_weight: individualProduct || null,
    individual_weight_packaging: individualProductPackaging || null,
    your_weigh_in: finalWeight || null,
    variation_categories: variationCategories || null,
    certificates: certificates || null,
    country_origin: countryOrigin || null,
    functional_unit_num: functionalUnitNum || null,
    functional_unit: functionalUnit || null,
    country_code: countryCode || null,
    lifetime_functional: lifetimeFunctional || null,
    lifetime_functional_unit: lifetimeFunctionalUnit || null,
    functional_unit_desc: functionalUnitDesc || null,
    waste_weight: wasteWeight || null,
    total_weight: totalWeight || null,
    waste_weigh_in: wasteWeighIn || null,
    total_weigh_in: totalWeighIn || null,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/product/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      business_id: business,
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        confirmButtonColor: "#a9c1b4",
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();
      if (callback) callback();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        color: "#476355",
        background: "#f1f8ef",
      });
      console.log(error);
    });
};

export const addProductYearTab = ({ yearData }) => {
  const config = {
    method: "post",
    url: baseUrl + "/api/business/product/add-year-tab",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    data: {
      year: yearData,
    },
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    })
    .catch(function (error) {
      console.log(error);
    });

  // return ;
};

export const getProductYearTabList = ({ setYearTabList }) => {
  const config = {
    method: "get",
    url: baseUrl + "/api/business/product/year-tab",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
  };

  axios(config)
    .then(function (response) {
      const data = response.data.data.map((year) => {
        return year.year;
      });
      setYearTabList(data);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getSubgroupProductList = ({
  setSubgroups = function () {
    return;
  },
  setSharedSubgroups = function () {
    return;
  },
  yearData,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");

  var config = {
    method: "get",
    url: baseUrl + "/api/business/subgroup-product/list",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
    },
    params: {
      year: year ? year : yearData ? yearData : null,
    },
  };

  axios(config)
    .then(function (response) {
      setSubgroups(response.data.data);
      setSharedSubgroups(response.data.shared);
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteSubgroupProduct = ({
  id,
  callback,
  is_shared = false,
  shared_business = null,
  shared_admin_id = null,
}) => {
  var data = JSON.stringify({
    is_shared: is_shared,
    shared_business: shared_business,
    shared_admin_id: shared_admin_id,
  });
  var config = {
    method: "delete",
    url: baseUrl + "/api/business/subgroup-product-delete/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
    });
};

export const createSubgroupProduct = ({
  name,
  is_shared = false,
  shared_business = null,
  shared_admin_id = null,
  setErrorMessage = function () {
    return;
  },
  setNewSubgroupId = function () {
    return;
  },
  callback,
}) => {
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  var data = JSON.stringify({
    name: name,
    year: year,
    is_shared: is_shared,
    shared_business: shared_business,
    shared_admin_id: shared_admin_id,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/subgroup-product/add",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      setNewSubgroupId(response.data);
      Swal.fire({
        title: "Success!",
        icon: "success",
        // text: error,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      setErrorMessage();

      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      // Swal.fire(
      //   "Error!",
      //   error,
      //   "error"
      // );
      setErrorMessage(error.response.data);
      Swal.fire({
        title: errorTranslate(),
        icon: "error",
        text: defaultAddErrorMessage,
        confirmButtonColor: "#a9c1b4",
        // width: 600,
        // padding: '3em',
        color: "#476355",
        background: "#f1f8ef",
      });
      // setSaving(false)
    });
};

export const updateSubgroupProduct = ({
  id,
  name,
  shared_business = null,
  is_shared = false,
  setErrorMessage = function () {
    return;
  },
  callback,
}) => {
  var data = JSON.stringify({
    name: name,
    shared_business: shared_business,
    is_shared: is_shared,
  });

  var config = {
    method: "put",
    url: baseUrl + "/api/business/subgroup-product-update/" + id,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      // Swal.fire({
      //   title: "Success!",
      //   icon: "success",
      //   confirmButtonColor: "#a9c1b4",
      //   color: "#476355",
      //   background: "#f1f8ef",
      // });
      setErrorMessage();
      if (callback) callback();
    })
    .catch(function (error) {
      setErrorMessage(error.response.data);
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: "error",
      //   text: defaultAddErrorMessage,
      //   confirmButtonColor: "#a9c1b4",
      //   color: "#476355",
      //   background: "#f1f8ef",
      // });
      console.log(error);
    });
};
